import type { SidePanel } from '../types';

export const CardealerSubjects: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./CardealerSubjectsPanel.vue')),
};
